import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import TopNavigation from "../components/new-landing-page/TopNavigation";
import "../styles/landing.scss";
import TopBanner from "../components/new-landing-page/banner/TopBanner";
import Footer from "../components/new-landing-page/Footer";
import SecondaryFooter from "../components/new-landing-page/SecondaryFooter";
import Section from "../components/new-landing-page/sections/Section";
import Numbers from "../components/new-landing-page/sections/Numbers";
import ComparisonTable from "../components/new-landing-page/advantages/ComparisonTable";
import BulletsSection from "../components/new-landing-page/bullets-section/BulletsSection";
import Challenges from "../components/new-landing-page/challenges/Challenges";
import GetStartedSection from "../components/new-landing-page/challenges/GetStartedSection";
import UseCaseAccordion from "../components/new-landing-page/usecases/UseCaseAccordion";
import Testimonials from "../components/new-landing-page/testimonials/Testimonials";
import testingContent from "../content/testingContent";

const NewLandingPage = () => {
  return (
    <Container fluid className="container-div">
      <Row>
        <Col>
          <Container>
            <TopNavigation />
          </Container>
          <TopBanner content={testingContent} />
          <Numbers />
          <Section content={testingContent.sectionContent} link={testingContent.sectionButtonLink} />
          <ComparisonTable content={testingContent.comparisonTable} />
          <BulletsSection />
          <Challenges content={testingContent.challenges} heading={testingContent.challengesHeading} />
          {/* <Testimonials /> */}
          <GetStartedSection content={testingContent.getStartedSection} />
          <UseCaseAccordion content={testingContent.useCases}/>
          <SecondaryFooter />
          <Footer />
        </Col>
      </Row>
    </Container>
  );
};

export default NewLandingPage;
